import * as martinez from 'martinez-polygon-clipping'
import { type $Hole, Model } from 'metalworks-domain'
import { BufferGeometry, Group, Line, LineBasicMaterial, Vector3 } from 'three'

import { BRAND_PRIMARY_COLOR } from '../metalworksTheme'
import { polygonsToPaths } from './utils'

export const createSelectedFeatureOutline = ($feature: $Hole) => {
  const polygons = $feature.$polygons as martinez.Geometry[]

  // Even after merging there could be multiple paths.
  // (corner holes for example)
  const mergedPolygons = polygons.reduce<martinez.Geometry>(martinez.union, [[[]]])
  const paths = polygonsToPaths(mergedPolygons)

  const material = new LineBasicMaterial({
    color: BRAND_PRIMARY_COLOR,
    linewidth: 3,
    linecap: 'round',
    linejoin: 'round',
  })

  const group = new Group()

  // Rotation of the rendered plate is done after the 3D plate is rendered - the whole arm is rotated and positioned.
  // That means the hole itself is not rotated in the domain. So we need to rotate the outline here manually.
  const thickness = $feature.$plate.thickness
  const bend = $feature.$plate.$activeBend
  const rotateX = bend?.orientation === Model.BendOrientation.Horizontal && $feature.$absCoords.y > bend.$middlePoint.y
  const rotateY = bend?.orientation === Model.BendOrientation.Vertical && $feature.$absCoords.x > bend.$middlePoint.x
  if (rotateX) {
    group.rotateX(Math.PI / 2)
    group.position.set(-$feature.$absCoords.x, 0, -$feature.$absCoords.y + thickness)
  } else if (rotateY) {
    group.rotateY(Math.PI / 2)
    group.position.set(0, -$feature.$absCoords.y, $feature.$absCoords.x + thickness)
  } else {
    group.position.set(-$feature.$absCoords.x, -$feature.$absCoords.y, 1.25)
  }

  for (const path of paths) {
    const points = path.getPoints().map(p => new Vector3(p.x, p.y, 0))
    const geometry = new BufferGeometry().setFromPoints(points)
    const line = new Line(geometry, material)

    group.add(line)
  }

  return group
}
